import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import { X, AlertCircle, Info, Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FlashInfo = ({ pageName = 'homepage' }) => {
  const [flashInfo, setFlashInfo] = useState([]);
  const [dismissedInfo, setDismissedInfo] = useState([]);

  useEffect(() => {
    fetchFlashInfo();
  }, [pageName]);

  const fetchFlashInfo = async () => {
    try {
      const response = await axios.get(`${API}/flash-info/${pageName}`);
      setFlashInfo(response.data);
    } catch (error) {
      console.error('Error fetching flash info:', error);
    }
  };

  const handleDismiss = (infoId) => {
    setDismissedInfo([...dismissedInfo, infoId]);
  };

  const getIcon = (type) => {
    switch (type) {
      case 'urgent':
        return <AlertCircle className="w-5 h-5" />;
      case 'promotion':
        return <Sparkles className="w-5 h-5" />;
      default:
        return <Info className="w-5 h-5" />;
    }
  };

  const getVariantClass = (type) => {
    switch (type) {
      case 'urgent':
        return 'border-red-200 bg-red-50 text-red-900';
      case 'promotion':
        return 'border-green-200 bg-green-50 text-green-900';
      default:
        return 'border-blue-200 bg-blue-50 text-blue-900';
    }
  };

  const getIconColor = (type) => {
    switch (type) {
      case 'urgent':
        return 'text-red-600';
      case 'promotion':
        return 'text-green-600';
      default:
        return 'text-blue-600';
    }
  };

  const visibleFlashInfo = flashInfo.filter(
    info => !dismissedInfo.includes(info.id)
  );

  if (visibleFlashInfo.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3 mb-6">
      {visibleFlashInfo.map((info) => (
        <Alert
          key={info.id}
          className={`relative ${getVariantClass(info.type)} border-l-4 shadow-sm`}
        >
          <div className="flex items-start">
            <div className={`mt-0.5 ${getIconColor(info.type)}`}>
              {getIcon(info.type)}
            </div>
            <div className="flex-1 ml-3">
              <AlertTitle className="font-semibold text-base mb-1">
                {info.title}
              </AlertTitle>
              <AlertDescription className="text-sm">
                {info.message}
              </AlertDescription>
            </div>
            <button
              onClick={() => handleDismiss(info.id)}
              className={`ml-4 ${getIconColor(info.type)} hover:opacity-70 transition-opacity`}
              aria-label="Fermer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </Alert>
      ))}
    </div>
  );
};

export default FlashInfo;
